import { render } from "./ColaboradorRecepcaoView.vue?vue&type=template&id=3bff2853"
import script from "./ColaboradorRecepcaoView.vue?vue&type=script&lang=js"
export * from "./ColaboradorRecepcaoView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__